import React, { useState } from 'react';
import styles from '../../styles/Dashboard/TenantConsentModals.module.css';

const API_BASE_URL = import.meta.env.VITE_API_URL;

const TenantConsentModals = ({ tenantUserId, documentType, closeModal, refreshDocuments }) => {
  const [formValues, setFormValues] = useState({
    creditScore: '',
    annualIncome: '',
	criminalHistory: '',
	rentalEventHistory: ''
  });
  
  const CRIMINAL_HISTORY_OPTIONS = ['None', 'Misdemeanor', 'Felony'];
  const ADVERSE_EVENT_OPTIONS = ['None', 'Eviction', 'Civil Litigation', 'Other'];


  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormValues(prev => ({ ...prev, [name]: value }));
  };

  const submitConsent = () => {
    fetch(`${import.meta.env.VITE_API_URL}/users/documents/${tenantUserId}/${documentType}`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        consentGiven: true,
        paymentMade: true,
        dataReceived: true,
        dataReviewed: false,
        ...formValues
      }),
    })
    .then(res => {
      if (!res.ok) throw new Error('Failed to submit data.');
      return res.json();
    })
    .then(() => {
      refreshDocuments();
      closeModal();
    })
    .catch(err => console.error("Submission error:", err));
  };

  const renderForm = () => {
    switch (documentType) {
      case "Credit Score":
        return (
          <label>
            Credit Score (300-850):
            <input 
              type="number" 
              name="creditScore" 
              min="300" 
              max="850" 
              onChange={handleChange}
              className={styles.inputField}
            />
          </label>
        );
      case "Proof of Income":
        return (
          <label>
            Annual Income ($30k–$250k):
            <input 
              type="number" 
              min="30000" 
              max="250000" 
              name="annualIncome" 
              onChange={handleChange}
            />
          </label>
        );
      case "Background Check":
        return (
          <>
			<label>
			  Criminal History:
			  <select 
				name="criminalHistory" 
				value={formValues.criminalHistory || 'None'} 
				onChange={handleChange}
			  >
				{CRIMINAL_HISTORY_OPTIONS.map(opt => (
				  <option key={opt} value={opt}>{opt}</option>
				))}
			  </select>
			</label>


          <label>
            Adverse Rental Events:
            <select name="rentalEventHistory" value={formValues.rentalEventHistory || 'None'} onChange={handleChange}>
              <option value="None">None</option>
			  <option value="Lease Violation">Lease Violation</option>
			  <option value="Civil Litigation">Civil Litigation</option>
			  <option value="Eviction">Eviction</option>
				{/* Add more specific Massachusetts-compliant values if needed */}
            </select>
          </label>
          </>
        );
      default:
        return <p>No form available for this document type.</p>;
    }
  };

  return (
    <div className={styles.modalOverlay}>
      <div className={styles.modalContent}>
        <h2>{documentType} Verification</h2>
        <p className={styles.description}>
          This data will typically be fetched from an external API. For demonstration purposes, please provide your details manually.
        </p>

        {renderForm()}

        <div className={styles.modalActions}>
          <button onClick={submitConsent}>Submit</button>
          <button onClick={closeModal}>Cancel</button>
        </div>
      </div>
    </div>
  );
};

export default TenantConsentModals;
